import { QueryClient, useQuery, UseQueryResult } from '@tanstack/react-query';
import { type User } from '../../shared/types';
import { getUser } from '../utilities/api';

export const queryKeys = {
    getUser: () => ['user', 'get'],
};

export const useUser = (): UseQueryResult<User, Error> => {
    return useQuery({ queryKey: queryKeys.getUser(), queryFn: getUser, retry: false, staleTime: 30000 });
};

export const invalidateUser = (queryClient: QueryClient): void => {
    queryClient.invalidateQueries({ queryKey: queryKeys.getUser() });
};
